import api from './api.js';

export const assignmentService = {
  // Get all assignments for current user
  getAssignments: (params = {}) => api.get('/assignments', { params }),
  
  // Get assignment by ID
  getAssignment: (id) => api.get(`/assignments/${id}`),
  
  // Create new assignment (teacher only)
  createAssignment: (data) => api.post('/assignments', data),
  
  // Update assignment (teacher only)
  updateAssignment: (id, data) => api.put(`/assignments/${id}`, data),
  
  // Delete assignment (teacher only)
  deleteAssignment: (id) => api.delete(`/assignments/${id}`),
  
  // Submit assignment (student only)
  submitAssignment: (id, data) => api.post(`/assignments/${id}/submit`, data),
  
  // Get assignment submissions (teacher only)
  getSubmissions: (assignmentId, params = {}) => 
    api.get(`/assignments/${assignmentId}/submissions`, { params }),
  
  // Get specific submission
  getSubmission: (assignmentId, submissionId) => 
    api.get(`/assignments/${assignmentId}/submissions/${submissionId}`),
  
  // Grade submission (teacher only)
  gradeSubmission: (assignmentId, submissionId, data) => 
    api.post(`/assignments/${assignmentId}/submissions/${submissionId}/grade`, data),
  
  // Get my submissions (student only)
  getMySubmissions: (params = {}) => api.get('/assignments/submissions', { params }),
  
  // Get assignments by class (teacher only)
  getAssignmentsByClass: (classId, params = {}) => 
    api.get(`/assignments/class/${classId}`, { params }),
  
  // Upload assignment file
  uploadAssignmentFile: (formData) => 
    api.post('/assignments/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  
  // Download assignment file
  downloadAssignmentFile: (fileId) => 
    api.get(`/assignments/files/${fileId}/download`, { responseType: 'blob' }),
  
  // Get assignment statistics (teacher only)
  getAssignmentStats: (assignmentId) => 
    api.get(`/assignments/${assignmentId}/stats`),
  
  // Bulk grade submissions (teacher only)
  bulkGradeSubmissions: (assignmentId, data) => 
    api.post(`/assignments/${assignmentId}/bulk-grade`, data),
  
  // Export assignment grades (teacher only)
  exportGrades: (assignmentId) => 
    api.get(`/assignments/${assignmentId}/export-grades`, { responseType: 'blob' }),
};
